import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';
import FullScreenHeader from '@/components/modals/FullScreenHeader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const divAppContent = ref();

const toggleAppFullScreen = () => {
  divAppContent.value.requestFullscreen();
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view, {
      name: "NavHeader",
      onAppFullScreen: _cache[0] || (_cache[0] = ($event: any) => (toggleAppFullScreen()))
    }),
    _createElementVNode("div", {
      id: "app-content",
      class: "bg-white",
      ref_key: "divAppContent",
      ref: divAppContent
    }, [
      _createVNode(FullScreenHeader),
      _createVNode(_component_router_view),
      _createVNode(_component_router_view, { name: "FooterMessage" })
    ], 512)
  ], 64))
}
}

})